import {
  Identifiable,
  Project,
  ProjectResource,
  Role,
  projectResource as pr,
  id,
  role,
} from "@planzone/dto";
import { linkResource } from "./resource";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedPlanzoneResource, LinkedResource } from "./types";

function linkProjectResource(httpClient: HttpClient) {
  return function link(
    projectResource: LinkedResource<Identifiable<ProjectResource>>,
  ): Promise<Identifiable<ProjectResource>> {
    return Promise.all([
      httpClient
        .sendHttpRequest<Identifiable<Project>>({
          endpoint: projectResource._links.project.href,
          baseUrl: "",
          method: HttpMethods.GET,
        })
        .then((project) => ({ project })),
      httpClient
        .sendHttpRequest<Identifiable<Role>>({
          endpoint: projectResource._links.role.href,
          baseUrl: "",
          method: HttpMethods.GET,
        })
        .then((role) => ({ role }))
        .catch(() => ({ role: { uuid: id, ...role } })),
      httpClient
        .sendHttpRequest<LinkedPlanzoneResource>({
          endpoint: projectResource._links.member.href,
          baseUrl: "",
          method: HttpMethods.GET,
        })
        .then((resource) => linkResource(httpClient)(resource))
        .then((resource) => ({ resource })),
    ])
      .then((responses) =>
        responses.reduce<Identifiable<ProjectResource>>(
          (projectResource, chunk) => ({ ...projectResource, ...chunk }),
          projectResource.resource
            ? {
                ...pr,
                ...projectResource,
                resource: {
                  ...projectResource.resource,
                  tags: projectResource.resource.tags.map((tag) =>
                    // @ts-ignore
                    typeof tag === "string" ? { name: tag } : tag,
                  ),
                },
              }
            : { ...pr, ...projectResource },
        ),
      )
      .catch((e) => Promise.reject(e));
  };
}

export { linkProjectResource };
